export const ZOOM_MEETING_STATUS = {
  MEETING_STATUS_ENDED: "MEETING_STATUS_ENDED",
  MEETING_STATUS_WAITINGFORHOST: "MEETING_STATUS_WAITINGFORHOST",
};

export const GET_ZOOM_APP_URL = "host/fetch/exlycon/url";
